import { render } from "./AxeAnimation.vue?vue&type=template&id=7608f4aa&scoped=true&ts=true"
import script from "./AxeAnimation.vue?vue&type=script&lang=ts"
export * from "./AxeAnimation.vue?vue&type=script&lang=ts"

import "./AxeAnimation.vue?vue&type=style&index=0&id=7608f4aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7608f4aa"]])

export default __exports__